export { LightBulbIcon } from "./light-bulb";
